import React, { useEffect, useState } from 'react';
import { BsViewStacked } from 'react-icons/bs';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { io, Socket } from 'socket.io-client';
import { v4 as uuidv4 } from 'uuid';
import { useSteps } from '../../contexts/stepContext';
import apiPlaca from '../../services/apiPlaca';
import { Title } from '../../styles/global';
import { errorToast, warnToast } from '../../utils/toast';
import { Content, GoBack } from '../BodyStep/styles';
import Button from '../Button';
import Loading from '../Loading';
import Progress from '../Progress';
import {
  Container,
  ContainerUpload,
  DirectoryIcon,
  DirectoryInput,
  Message,
  PathInput,
  TextLabel,
  UploadLine,
} from './styles';

const UploadFile: React.FC = () => {
  const keyProcessGen = (): string => {
    const key = uuidv4();
    return String(key);
  };

  const {
    handleInitialCurrentStep,
    handleChangeCurrentStep,
    handleReturnCurrentStep,
    getDiffPlates,
    processingPlates,
    setProcessingPlates,
    progress,
    setProgress,
  } = useSteps();

  const [foundPage, setFoundPage] = useState(true);
  const [loading] = useState(false);
  const [upLoading, setUpLoading] = useState(false);
  const [fileName, setFileName] = useState('');
  const [file, setFile] = useState<File>();
  const [, setHasProcess] = useState(false);
  const [socket] = useState<Socket>(
    io(
      (process.env.REACT_APP_ENVIRONMENT === 'dev'
        ? process.env.REACT_APP_BASE_URL_DEV
        : process.env.REACT_APP_BASE_URL_PROD) || 'http://localhost:3333',
    ),
  );
  const [keyProcess, setKeyProcess] = useState(() => {
    const storageKey = localStorage.getItem('@keyprocess');
    if (!storageKey) {
      const key = keyProcessGen();
      return key;
    }
    setUpLoading(true);
    setHasProcess(true);
    return storageKey;
  });

  const saveFileName = e => {
    const fileData = e.target.files[0];
    const compare = fileData.name.split('.', 2);

    if (compare[1] !== 'csv') {
      warnToast('Por favor Selecione um arquivo do tipo ".csv"');
      return;
    }
    setFile(fileData);
    setFileName(fileData.name);
  };

  const handleUploadFile = () => {
    if (fileName === '') {
      warnToast('Nenhum Arquivo foi Selecionado');
    } else {
      uploadFile();
      setUpLoading(true);
    }
  };

  const uploadFile = async () => {
    const formData = new FormData();

    if (!file) {
      warnToast('Deve selecionar um arquivo csv');
      return;
    }
    formData.append('file', file);

    const response = await apiPlaca.post('CSV', formData);

    if (response.data.message) {
      errorToast(response.data.message);
      failedProcessBackOperations();
      return;
    }

    processPlates();
  };

  const failedProcessBackOperations = () => {
    setFoundPage(true);
    localStorage.removeItem('@keyprocess');
    setKeyProcess('');
    setHasProcess(false);
    handleInitialCurrentStep();
  };

  const handleSetProcessingPlates = (value: number) => {
    setProcessingPlates(value);
  };

  async function processPlates() {
    socket.emit('partialValue', { process: `${keyProcess}` });
    localStorage.setItem('@keyprocess', String(keyProcess));
    setHasProcess(true);
    socket.on('platesCount', data => {
      handleSetProcessingPlates(data.plates);
    });
  }

  const handleSetProgress = (value: number) => {
    setProgress(value);
  };

  async function handleShowDiffPlates() {
    localStorage.removeItem('@keyprocess');
    setKeyProcess('');
    setHasProcess(false);
    getDiffPlates();
    handleChangeCurrentStep();
  }

  useEffect(() => {
    socket.emit('room', { process: `${keyProcess}` });
    socket.on('foundPage', data => {
      setFoundPage(data.found);
    });

    if (foundPage === true) {
      socket.on('partialValue', data => {
        handleSetProgress(data.progress);
      });
    }
  }, [socket]);

  return (
    <>
      <Content>
        <GoBack onClick={handleReturnCurrentStep}>
          <FaArrowLeft size={16} />
          voltar
        </GoBack>
        <Title>Upload do Arquivo CSV</Title>
        <Container>
          {!upLoading ? (
            <>
              <ContainerUpload>
                <h3>Selecione o arquivo.csv no diretorio</h3>
                <UploadLine>
                  <PathInput
                    type="text"
                    placeholder={
                      fileName ? ` ${fileName}` : ' NomeDoArquivo.csv'
                    }
                    disabled
                  />
                  <TextLabel htmlFor="uploadFile">
                    <DirectoryIcon />
                  </TextLabel>
                  <DirectoryInput
                    type="file"
                    id="uploadFile"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    onChange={saveFileName}
                  />
                </UploadLine>
              </ContainerUpload>
            </>
          ) : (
            <>
              {loading && <Loading />}
              <ContainerUpload>
                {progress < 100 && foundPage ? (
                  <>
                    <Message>O arquivo foi carregado.</Message>
                    <Message>
                      {processingPlates} placas estão sendo processadas
                    </Message>
                    <Message>
                      Aguarde um momento enquanto realizamos esta operação
                    </Message>
                    <Progress />
                  </>
                ) : (
                  <>
                    {!foundPage ? (
                      <>
                        <Message>O arquivo foi carregado.</Message>
                        <Message>
                          Porém não foi possivel fazer o processamento das
                          placas
                        </Message>
                        <Message>Tente novamente mais tarde</Message>
                      </>
                    ) : (
                      <>
                        <Message>Todas as placas foram processadas.</Message>
                        <Message>
                          Clique em Detalhes para mais informações
                        </Message>
                      </>
                    )}
                  </>
                )}
              </ContainerUpload>
            </>
          )}
        </Container>
        {!foundPage ? (
          <Button
            title="Voltar para Operacoes"
            onClick={failedProcessBackOperations}
            icon={BsViewStacked}
          />
        ) : (
          <Button
            title={progress < 100 ? 'Confirmar' : 'Detalhes'}
            onClick={progress < 100 ? handleUploadFile : handleShowDiffPlates}
            icon={FaArrowRight}
          />
        )}
      </Content>

      {loading && <Loading />}
    </>
  );
};

export default UploadFile;
